import { useContext } from 'react';
import { UsersContext } from '../context/UserContext';

export function useUser() {
  const context = useContext(UsersContext);

  return context;
}
